import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchListaConceptos, getTiposConceptos } from '../../../../actions/tiposActions';
import { putEliminaConceptoFinal, putEditaConceptoFinal } from '../../../../api/axios';
import { toast } from '../../../../utilities/appToast';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import BigSpinner from '../../../General/BigSpinner';
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import { LiquidacionesBtnCrear, LiquidacionesBtnGuardar, LiquidacionesBtnLimpiar, LiquidacionesEmptyState } from '../../shared/LiquidacionesButtons';

// Wrapper para usar hooks en class component
function ListConceptosWrapper(props) {
  const navigate = useNavigate();
  return <ListConceptos {...props} navigate={navigate} />;
}

class ListConceptos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            dropdownSubTipo: {
                idSubTipo: null,
                label: ""
            },
            editingConcepto: null,
            openEditPopoverId: null,
            tiposConceptosLocal: []
        }
    };

    componentDidMount() {
        this.props.fetchListaConceptos();
        this.loadLocalFallbackData();
    }

    loadLocalFallbackData = async () => {
        try {
            const conceptosRes = await getTiposConceptos();
            const conceptosRaw = Array.isArray(conceptosRes)
                ? conceptosRes
                : (Array.isArray(conceptosRes?.tiposNovedades)
                    ? conceptosRes.tiposNovedades
                : (Array.isArray(conceptosRes?.listaConceptoNovedades)
                    ? conceptosRes.listaConceptoNovedades
                    : (Array.isArray(conceptosRes?.elementos) ? conceptosRes.elementos : [])));
            const tiposConceptosLocal = conceptosRaw.map((item) => ({
                ...item,
                idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? "",
                detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? "",
                idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? 0,
                idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idSubTipo ?? item?.IdSubTipo ?? 0,
                descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? "",
                mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
            }));

            this.setState({ tiposConceptosLocal });
        } catch (_) {
            // fallback silencioso
        }
    };

    loadInputs(tipoConcepto) {

        const { detalleConcepto, idSubTipo, descripcionSubTipoNovedad } = tipoConcepto;

        this.setState({ 
            descripcion: detalleConcepto,
            editingConcepto: tipoConcepto,
            openEditPopoverId: tipoConcepto.idConcepto,
            dropdownSubTipo: { 
                ...this.state.dropdownSubTipo, 
                idSubTipo: idSubTipo,
                label: descripcionSubTipoNovedad
            }
        });
    }

    closeEditPopover = () => {
        this.setState({
            editingConcepto: null,
            openEditPopoverId: null,
            descripcion: "",
            dropdownSubTipo: {
                idSubTipo: null,
                label: ""
            }
        });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

  editarConcepto = (idConcepto) => {
    const { descripcion, dropdownSubTipo } = this.state;

        let datos = {
            idConcepto: idConcepto,
            idTipoNovedad: dropdownSubTipo.idSubTipo,
            descripcion: descripcion
        }
        let post = putEditaConceptoFinal(datos);

        post.then(res => {
            this.componentDidMount();
            this.closeEditPopover();
            toast.success("El concepto fue actualizado con exito");
        }).catch(err => {
            toast.error("No pudimos editar el concepto");
        });
    }

    eliminarConcepto = (idTipoNovedad) => {

        let data = {
            IdTipoNovedad: idTipoNovedad
        };

        let post = putEliminaConceptoFinal(data);

        post.then(res => {
            const data = res?.data;
            const successMessage =
                data?.mensajen ||
                data?.Mensajen ||
                data?.conceptoAnulado ||
                data?.ConceptoAnulado ||
                data?.mensaje ||
                data?.Mensaje;

            if (successMessage) {
                toast.success(successMessage);
            }
            this.componentDidMount();
        }).catch(err => {
            const errores = err?.response?.data?.errores;
            if (Array.isArray(errores))
                errores.forEach(error => toast.error(error.item2));
            else
                toast.error("No se pudo eliminar el concepto");
        });
    }

    gotoNuevoConcepto = () => {
        this.props.navigate("/Conceptos/Nuevo");
    }
    render() {
        const { loadingTipos } = this.props;
        const { descripcion, openEditPopoverId } = this.state;
        let tiposConceptosRaw = this.props.tiposConceptos;
        let tiposConceptos = Array.isArray(tiposConceptosRaw)
            ? tiposConceptosRaw
            : (Array.isArray(tiposConceptosRaw?.tiposNovedades)
                ? tiposConceptosRaw.tiposNovedades
            : (Array.isArray(tiposConceptosRaw?.listaConceptoNovedades)
                ? tiposConceptosRaw.listaConceptoNovedades
                : (Array.isArray(tiposConceptosRaw?.elementos)
                    ? tiposConceptosRaw.elementos
                    : [])));

        tiposConceptos = tiposConceptos.map((item) => ({
            ...item,
            idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? "",
            detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? "",
            idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? 0,
            idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idSubTipo ?? item?.IdSubTipo ?? 0,
            descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? "",
            mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
        }));

        if (tiposConceptos.length === 0 && this.state.tiposConceptosLocal.length > 0) {
            tiposConceptos = this.state.tiposConceptosLocal;
        }

        const hasDataToRender = tiposConceptos.length > 0;

        return (
            <div className="container gestion-liquidaciones liquidaciones-modulo">
                <LiquidacionesPageHeader
                    title="Gestión de conceptos"
                    subtitle="Administrá y mantené los conceptos de liquidación."
                    actions={(
                        <LiquidacionesBtnCrear onClick={this.gotoNuevoConcepto}>
                            Crear concepto
                        </LiquidacionesBtnCrear>
                    )}
                />

                {(loadingTipos && !hasDataToRender) ? (
                    <BigSpinner message="Cargando conceptos de liquidacion..." />

                ) : !hasDataToRender ? (
                    <LiquidacionesEmptyState>
                        No se encontraron conceptos de liquidación
                    </LiquidacionesEmptyState>

                ) : (

                    <div className="list-group-item col-12 animated fadeIn px-0 border-0 bg-transparent">
                        <div className="table-responsive card shadow-sm border-0 overflow-hidden">
                            <table className="table mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th className="small text-muted text-uppercase fw-semibold">Nombre</th>
                                        <th className="small text-muted text-uppercase fw-semibold">Acción</th>
                                        <th className="small text-muted text-uppercase fw-semibold">Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    tiposConceptos.map((tipoConcepto, i) => {
                                        return (
                                                <tr key={i} className="hover-background-color">
                                                    <td><small>{tipoConcepto.idConcepto}</small></td>
                                                    <td><small>{tipoConcepto.descripcionSubTipoNovedad}</small></td> 
                                                    <td>
                                                    {
                                                        tipoConcepto.mostrarBotonEliminar ?
                                                        <div className="d-inline-flex align-items-center gap-1">

                                                            <OverlayTrigger
                                                                key={`overlay-edit-${i}`}
                                                                trigger="click"
                                                                rootClose={true}
                                                                show={openEditPopoverId === tipoConcepto.idConcepto}
                                                                onToggle={(nextShow) => {
                                                                    if (nextShow) {
                                                                        this.loadInputs(tipoConcepto);
                                                                    } else if (openEditPopoverId === tipoConcepto.idConcepto) {
                                                                        this.closeEditPopover();
                                                                    }
                                                                }}
                                                                placement={"left"}
                                                                containerPadding={16}
                                                                popperConfig={{
                                                                    modifiers: [
                                                                        {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [0, 10]
                                                                            }
                                                                        },
                                                                        {
                                                                            name: 'flip',
                                                                            options: {
                                                                                fallbackPlacements: ['bottom', 'top']
                                                                            }
                                                                        },
                                                                        {
                                                                            name: 'preventOverflow',
                                                                            options: {
                                                                                boundary: 'viewport',
                                                                                padding: 16
                                                                            }
                                                                        }
                                                                    ]
                                                                }}
                                                                overlay={
                                                                    <Popover id={`popover-edit-${i}`} style={{ minWidth: '320px', maxWidth: '360px' }}>
                                                                        <Popover.Header as="h3" className="fw-bold bg-light border-bottom">
                                                                            Editar concepto
                                                                        </Popover.Header>
                                                                        <Popover.Body>
                                                                            <div className="d-flex flex-column gap-3">
                                                                                <small className="text-muted">Actualizá el nombre sin salir del listado.</small>

                                                                                <div>
                                                                                    <label className="form-label small text-muted mb-1">Nombre</label>
                                                                                    <input 
                                                                                        type="text" 
                                                                                        name="descripcion"
                                                                                        className="form-control form-control-sm" 
                                                                                        value={descripcion}
                                                                                        onChange={this.myChangeHandler} 
                                                                                        maxLength="50"
                                                                                    />
                                                                                </div>

                                                                                <div className="d-flex justify-content-end gap-2">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm gestion-liquidaciones-btn-limpiar"
                                                                                        onClick={this.closeEditPopover}
                                                                                    >
                                                                                        Cancelar
                                                                                    </button>

                                                                                    <button 
                                                                                        type="button"
                                                                                        onClick={() => this.editarConcepto(tipoConcepto.idTipoNovedad)}
                                                                                        className="btn btn-sm gestion-liquidaciones-btn-guardar"
                                                                                        disabled={descripcion === ""}
                                                                                    >
                                                                                        Actualizar
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <button 
                                                                    type="button" 
                                                                    title="Editar" 
                                                                    className={`btn ${openEditPopoverId === tipoConcepto.idConcepto ? 'gestion-liquidaciones-btn-guardar' : 'gestion-liquidaciones-btn-limpiar'}`}
                                                                >
                                                                    <i className="fa fa-clipboard" aria-hidden="true"/>
                                                                </button>
                                                            </OverlayTrigger>

                                                            <OverlayTrigger
                                                                key={`overlay-delete-${i}`}
                                                                trigger="click"
                                                                rootClose={true}
                                                                placement={"left"}
                                                                containerPadding={16}
                                                                popperConfig={{
                                                                    modifiers: [
                                                                        {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [0, 8]
                                                                            }
                                                                        },
                                                                        {
                                                                            name: 'flip',
                                                                            options: {
                                                                                fallbackPlacements: ['bottom', 'top']
                                                                            }
                                                                        },
                                                                        {
                                                                            name: 'preventOverflow',
                                                                            options: {
                                                                                boundary: 'viewport',
                                                                                padding: 16
                                                                            }
                                                                        }
                                                                    ]
                                                                }}
                                                                overlay={
                                                                    <Popover id={`popover-delete-${i}`}>
                                                                        <Popover.Header as="h3" className="fw-bold bg-light border-bottom">
                                                                            ¿Eliminar Concepto?
                                                                        </Popover.Header>
                                                                        <Popover.Body className="row justify-content-center">
                                                                            <button 
                                                                                className="btn btn-sm gestion-liquidaciones-btn-guardar col-auto"
                                                                                onClick={
                                                                                    () => this.eliminarConcepto(tipoConcepto.idTipoNovedad)
                                                                                }
                                                                            >
                                                                                Eliminar
                                                                            </button>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <button 
                                                                    title="Eliminar" 
                                                                    type="button" 
                                                                    className="btn color-rojo-megatone"
                                                                >
                                                                    <i className="fa fa-trash" aria-hidden="true"/>
                                                                </button>
                                                            </OverlayTrigger>

                                                        </div>
                                                        : ""
                                                    }
                                                    </td>
                                                </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    loadingTipos: state.tipos.loadingTipos,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto
});

export default connect(mapStateToProps, { 
    fetchListaConceptos
}) (ListConceptosWrapper);
